// extracted by mini-css-extract-plugin
module.exports =  {"root":"y0nJGTby1QhR8NvIukCU","frame":"EfhXT5Jo1rFnLBTW89n8","mobile":"gVG7Oh68NLLo78tlqtop","page":"QtITDKJHvCtTXitWo7aK","select":"Xlqho0OpDRkx11FHt5Sw"};